import { render, staticRenderFns } from "./UserListCard.vue?vue&type=template&id=12b811a8&scoped=true&"
import script from "./UserListCard.vue?vue&type=script&lang=ts&"
export * from "./UserListCard.vue?vue&type=script&lang=ts&"
import style0 from "./UserListCard.vue?vue&type=style&index=0&id=12b811a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b811a8",
  null
  
)

export default component.exports